import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-triangle-up",
  "use": "chevron-triangle-up-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-triangle-up\">\n<path d=\"M0.999999 9L8.29289 1.70711C8.68342 1.31658 9.31658 1.31658 9.70711 1.70711L17 9\" stroke=\"#724AE6\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol